import { render, staticRenderFns } from "./OtherSchoolEnrollment.vue?vue&type=template&id=0277af4f&scoped=true"
import script from "./OtherSchoolEnrollment.vue?vue&type=script&lang=js"
export * from "./OtherSchoolEnrollment.vue?vue&type=script&lang=js"
import style0 from "./OtherSchoolEnrollment.vue?vue&type=style&index=0&id=0277af4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0277af4f",
  null
  
)

export default component.exports